"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabsConfigurator = exports.TAB_PHRASES = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reactSortableHoc = require("react-sortable-hoc");

var _panel = _interopRequireDefault(require("../../control-components/panel"));

var _phrase = require("../../libs/translationsUtils/phrase");

var _SortableNavigationList = _interopRequireDefault(require("@insided/control/shared/SortableNavigationList"));

var _CategoryDefaultSetting = _interopRequireDefault(require("@insided/deprecated-preact-components/homepage-tabs/CategoryDefaultSetting"));

var _CategorySelection = _interopRequireDefault(require("@insided/destination/modules/Navigation/shared/CategorySelection"));

var _categories = require("@insided/shared/utils/categories");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Add = _interopRequireDefault(require("@insided/shared/icons/Add"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TAB_PHRASES = {
  categories: 'Category',
  recent_active: 'Recently Active',
  unanswered: 'Help Others'
};
exports.TAB_PHRASES = TAB_PHRASES;

var fetchPhraseByTab = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(tab) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (resolve) {
              (0, _phrase.fetchPhrase)('Forum', "tab.navigation.".concat(tab.phrase_suffix), function (phrase) {
                resolve(phrase);
              });
            });

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchPhraseByTab(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getName = function getName(phraseSuffix) {
  var _TAB_PHRASES;

  return (_TAB_PHRASES = TAB_PHRASES[phraseSuffix]) !== null && _TAB_PHRASES !== void 0 ? _TAB_PHRASES : 'Custom Tab';
};

var getKey = function getKey(phraseSuffix) {
  var _TAB_PHRASES2;

  return (_TAB_PHRASES2 = TAB_PHRASES[phraseSuffix]) !== null && _TAB_PHRASES2 !== void 0 ? _TAB_PHRASES2 : phraseSuffix;
};

var TabsConfigurator = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TabsConfigurator, _Component);

  var _super = _createSuper(TabsConfigurator);

  function TabsConfigurator() {
    var _this;

    (0, _classCallCheck2.default)(this, TabsConfigurator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      tabs: _this.props.tabs,
      fallbackPhrases: {},
      selectedCategories: _this.getSelectedCategoryList()
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "notifyChanges", function () {
      _this.props.onChange({
        tabs: _this.state.tabs,
        categories: _this.state.selectedCategories.map(function (category) {
          return parseInt(category.id);
        })
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onItemUpdated", function (newTabs) {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          tabs: newTabs
        });
      }, _this.notifyChanges);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onItemChange", function (idx, field, value) {
      var newTabs = (0, _toConsumableArray2.default)(_this.state.tabs); // @ts-expect-error

      newTabs[idx][field] = value;

      _this.onItemUpdated(newTabs);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onItemVisibilityChanged", function (idx) {
      _this.onItemChange(idx, 'enabled', !_this.state.tabs[idx].enabled);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onItemNameChanged", function (idx, newName) {
      _this.onItemChange(idx, 'phrase', newName);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCustomTabContentTypesChanged", function (idx, newContentTypes) {
      _this.onItemChange(idx, 'selectedContentTypes', newContentTypes);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCustomTabCategoriesChanged", function (idx, newCategories) {
      _this.onItemChange(idx, 'selectedCategories', newCategories);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCustomTabProductAreasChanged", function (idx, newProductAreas) {
      var newProductAreasIds = newProductAreas.map(function (productArea) {
        return String(productArea.id);
      });

      _this.onItemChange(idx, 'selectedProductAreaIds', newProductAreasIds);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeCategoryType", function (selectedCategories) {
      _this.setState({
        selectedCategories: selectedCategories
      }, function () {
        return _this.notifyChanges();
      });
    });
    return _this;
  }

  (0, _createClass2.default)(TabsConfigurator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchPhrases();
    }
  }, {
    key: "fetchPhrases",
    value: function () {
      var _fetchPhrases = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var phrases, fallbackPhrases;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Promise.all(this.props.tabs.map( /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(tab) {
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return fetchPhraseByTab(tab);

                          case 2:
                            return _context2.abrupt("return", _context2.sent);

                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 2:
                phrases = _context3.sent;
                fallbackPhrases = {};
                this.props.tabs.forEach(function (tab, i) {
                  if (TAB_PHRASES[tab.phrase_suffix]) {
                    fallbackPhrases[tab.phrase_suffix] = phrases[i];
                  }
                });
                this.setState({
                  fallbackPhrases: fallbackPhrases
                });

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchPhrases() {
        return _fetchPhrases.apply(this, arguments);
      }

      return fetchPhrases;
    }()
  }, {
    key: "getSelectedCategoryList",
    value: function getSelectedCategoryList() {
      var _this$props = this.props,
          categoriesList = _this$props.categoriesList,
          _this$props$categorie = _this$props.categories,
          categories = _this$props$categorie === void 0 ? [] : _this$props$categorie;
      var selectedCategoryList = [];

      if (categories.length) {
        categories.forEach(function (existingCategory) {
          var selectedCategory = (0, _categories.flattenCategoryList)((0, _categories.getMergedCategoryList)(categoriesList)).find(function (category) {
            return category.id.toString() === existingCategory.toString();
          });

          if (selectedCategory) {
            selectedCategoryList.push(selectedCategory);
          }
        });
      }

      return selectedCategoryList;
    }
  }, {
    key: "addCustomTab",
    value: function addCustomTab() {
      var _this2 = this;

      var tabs = this.state.tabs;
      var newCustomTab = {
        class: 'branded/_index-custom-tab',
        collapsed: false,
        enabled: true,
        phrase: 'Custom',
        phrase_suffix: window.crypto.randomUUID(),
        isCustom: true
      };
      var newTabs = [].concat((0, _toConsumableArray2.default)(tabs), [newCustomTab]);
      this.setState({
        tabs: newTabs
      }, function () {
        return _this2.notifyChanges();
      });
    }
  }, {
    key: "removeTab",
    value: function removeTab(tabIndex) {
      var _this3 = this;

      var tabs = this.state.tabs;
      var newTabs = (0, _toConsumableArray2.default)(tabs);
      newTabs.splice(tabIndex, 1);
      this.setState({
        tabs: newTabs
      }, function () {
        return _this3.notifyChanges();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          categoriesList = _this$props2.categoriesList,
          productAreasList = _this$props2.productAreasList;
      var _this$state = this.state,
          tabs = _this$state.tabs,
          selectedCategories = _this$state.selectedCategories;
      var updatedTabs = tabs.map(function (tab, idx) {
        var _tab$phrase, _tab$selectedContentT, _tab$selectedCategori, _tab$selectedProductA;

        return {
          key: getKey(tab.phrase_suffix),
          name: (_tab$phrase = tab.phrase) !== null && _tab$phrase !== void 0 ? _tab$phrase : getName(tab.phrase_suffix),
          isCustom: tab.isCustom,
          selectedContentTypes: (_tab$selectedContentT = tab.selectedContentTypes) !== null && _tab$selectedContentT !== void 0 ? _tab$selectedContentT : undefined,
          selectedCategories: (_tab$selectedCategori = tab.selectedCategories) !== null && _tab$selectedCategori !== void 0 ? _tab$selectedCategori : undefined,
          selectedProductAreaIds: (_tab$selectedProductA = tab.selectedProductAreaIds) !== null && _tab$selectedProductA !== void 0 ? _tab$selectedProductA : undefined,
          visibility: tab.enabled,
          categorySlot: tab.phrase_suffix === 'categories' && (0, _preact.h)(_CategoryDefaultSetting.default, {
            collapsed: tab.collapsed,
            onChange: function onChange(collapsed) {
              _this4.onItemChange(idx, 'collapsed', collapsed);
            }
          })
        };
      });
      return (0, _preact.h)("div", {
        className: "tabs-configurator ".concat(this.props.class)
      }, (0, _preact.h)("div", null, (0, _preact.h)("strong", null, "Default tabs"), (0, _preact.h)("p", null, "You can customise tabs by reordering, renaming, setting visibility and filtering on categories.")), (0, _preact.h)(_CategorySelection.default, {
        categoriesV2: categoriesList,
        selectedCategories: selectedCategories,
        onChangeSend: function onChangeSend(newCategoryList) {
          return _this4.onChangeCategoryType(newCategoryList);
        },
        label: "Filter topics on categories for default tabs"
      }), (0, _preact.h)(_SortableNavigationList.default, {
        canAddCustomLink: false,
        canItemOpenInNewTab: false,
        items: updatedTabs,
        categoriesList: categoriesList,
        productAreasList: productAreasList,
        onItemUpdated: function onItemUpdated(oldIndex, newIndex) {
          return _this4.onItemUpdated((0, _reactSortableHoc.arrayMove)(tabs, oldIndex, newIndex));
        },
        onItemVisibilityChanged: function onItemVisibilityChanged(index) {
          return _this4.onItemVisibilityChanged(index);
        },
        onItemNameChanged: function onItemNameChanged(index, newName) {
          return _this4.onItemNameChanged(index, newName);
        },
        onItemContentTypesChanged: function onItemContentTypesChanged(index, newContentTypes) {
          return _this4.onCustomTabContentTypesChanged(index, newContentTypes);
        },
        onItemCategoriesChanged: function onItemCategoriesChanged(index, newCategories) {
          return _this4.onCustomTabCategoriesChanged(index, newCategories);
        },
        onItemProductAreasChanged: function onItemProductAreasChanged(index, newProductAreas) {
          return _this4.onCustomTabProductAreasChanged(index, newProductAreas);
        },
        onItemRemoved: function onItemRemoved(index) {
          return _this4.removeTab(index);
        },
        showLabelsOnItems: true
      }), (0, _preact.h)(_Button.default, {
        type: "button",
        startIcon: (0, _preact.h)(_Add.default, {
          width: 24,
          height: 24
        }),
        className: "tabs-configurator_add-custom-tab",
        onClick: function onClick() {
          return _this4.addCustomTab();
        }
      }, "Add Custom Tab"), (0, _preact.h)("div", {
        className: "widget-configuration_info-box"
      }, (0, _preact.h)("strong", null, "\u2728 Tip"), (0, _preact.h)("p", null, "If you use quick links for your categories, it is recommended to not use the category tab as the first tab.")));
    }
  }]);
  return TabsConfigurator;
}(_preact.Component);

exports.TabsConfigurator = TabsConfigurator;

var TabsConfiguratorPanel = function TabsConfiguratorPanel(props) {
  return (0, _preact.h)(_panel.default, {
    collapsible: true,
    customClass: "homepage-widget",
    title: (0, _preact.h)("div", {
      className: "panel-title-with-switch"
    }, (0, _preact.h)("div", {
      className: "homepage-reorderable-panel-title"
    }, props.dragHandle, (0, _preact.h)("span", null, "Community category & discussions")), props.switcher)
  }, (0, _preact.h)(TabsConfigurator, props));
};

var _default = TabsConfiguratorPanel;
exports.default = _default;